// Defaults applied when an admin hasn't set a value for the matching
// `greeting_cards` customization field. Sourced here (not as CSS
// fallbacks in `var(--x, default)`) so the admin preview and the
// recipient flow stay in lockstep with one TS edit.
//
// Colors are the "warm cream + amber" palette; the font is Funnel
// Display 700 / 32px / 100% line-height. Update this file to change
// what an unconfigured greeting card looks like.

import type { GreetingCardFont } from './fontDefinitions'

export interface GreetingCardCustomizationDefaults {
  envelopeColor: string
  backgroundColor: string
  pageBackgroundColor: string
  fontColor: string
  // Same shape `findGreetingCardFont` returns so callers can do
  // `findGreetingCardFont(card.fontType) ?? DEFAULTS.font` without a
  // type juggling layer.
  font: GreetingCardFont
}

export const DEFAULT_GREETING_CARD_CUSTOMIZATION: GreetingCardCustomizationDefaults = {
  envelopeColor: '#FFB700',
  backgroundColor: '#EEE5C0',
  pageBackgroundColor: '#FBF8EB',
  fontColor: '#474640',
  font: {
    family: 'Funnel Display',
    label: 'Funnel Display',
    weight: 700,
    fontSize: '2rem',
    lineHeight: '100%',
  },
}
